
@if (surveyData()) {
  <section
    class="survey__container"
    [style]="'--background-color-survey: ' + surveyData()!.style.survey_color + '; ' +
             '--text-color-survey: ' + surveyData()!.style.text_color + '; '"
  >
    @if (isBottomSheetMode()) {
      <app-drag-handle />
    }

    <header 
      class="survey__header"
      [style.background-color]="isDialogMode() ? surveyData()!.style.header_color : ''"
    >
      <div class="header__content">
        @if(surveyData()!.name) {
          <h1 class="header__title ci-heading-h5-semibold">
            {{ surveyData()!.name[lang()] }}
          </h1>
        }
        
        @if(surveyData()!.style.logo) {
          <img 
            class="header__logo" 
            [src]="surveyData()!.style.logo!.url" 
            [alt]="surveyData()!.style.logo!.original_name" 
          />
        }
      </div>


      <ci-icon-button
        class="survey__close-button"
        type="standard"
        name="close"
        (click)="close()"
      ></ci-icon-button>
    </header>

    @if (surveyForm()) {
      <form
        class="survey__form"
        [formGroup]="surveyForm()!"
      >
        <ci-scroll-fade
          [attr.height]="'50dvh'"
          [attr.background-color]="surveyData()!.style.survey_color"
        >
          <main class="survey__main">
            @if (fieldList() && fieldList().length > 0) {
              <ul class="survey__items">
                @for(field of fieldList(); track field.title; let i = $index) {
                  <li class="items__item">
                    @if (field.type === typeText ||
                         field.type === typeTextarea ||
                         field.type === typeEmail)
                    {
                      <app-text-field-wrapper
                        [field]="field"
                        [form]="surveyForm()!"
                        [formControlName]="field.type + '_' + i"
                        [isTypeEmail]="field.type === typeEmail"
                      />
                    }
                    @else if (field.type === typeSelectionUnique) {
                      <app-single-response-field-wrapper
                        [field]="field"
                        [form]="surveyForm()!"
                        [formControlName]="field.type + '_' + i"
                      />
                    }
                    @else if (field.type === typeSelectionMulti) {
                      <app-multiple-response-field-wrapper
                        [field]="field"
                        [form]="surveyForm()!"
                        [formControlName]="field.type + '_' + i"
                      />
                    }
                    @else if (field.type === typeSatisfactionLevel3 ||
                              field.type === typeSatisfactionLevel5)
                    {
                      <app-level-satisfaction-field-wrapper
                        [field]="field"
                        [form]="surveyForm()!"
                        [formControlName]="field.type + '_' + i"
                      />
                    }
                    @else {
                      <p class="ci-paragraph-p1-regular">
                        {{ 'Tipo de campo no soportado' | translate }}
                      </p>
                    }
                  </li>

                  @if( !isLastField(i) ) {
                    <hr class="item__divider" />
                  }
                }
              </ul>
            } @else {
              <p class="ci-heading-h6-s-semibold">
                {{ 'No hay preguntas disponibles en esta encuesta' | translate }}
              </p>
            }
          </main>
        </ci-scroll-fade>

        <footer class="survey__footer">
          <ci-button
            class="footer__send-button"
            class-name="ci-btn-primary-s-filled"
            type="submit"
            [aria-label]="'Enviar encuesta' | translate"
            (click)="onSubmit()"
          >
          {{ 'Enviar' | translate }}
        </ci-button>
        </footer>
      </form>
    }
  </section>
}
